// UpcomingTrainings.js

import React from 'react';
import { Link } from 'react-router-dom';
import { Tab, Tabs, Table, Button } from 'react-bootstrap';
import { isAuthenticated, getUser } from '../utils/auth';
import Swal from 'sweetalert2';

function UpcomingTrainings({ trainings, onDeleteTraining  }) {

  const loggedInUser = getUser();
  console.log ("loggedinuser ", loggedInUser);

  // Base API URL from environment variable
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const handleDelete = async (id) => {
    // Add logic to handle deleting training data
    console.log('Training deleted:', id);
    const result = await Swal.fire({
      icon: 'warning',
      text: 'Are you sure you want to delete this training?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });
    if (result.isConfirmed) {
      fetch(`${API_BASE_URL}/trainings/delete_training.php?id=${id}`, {
        method: 'DELETE',
        credentials: 'include',
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            onDeleteTraining(id); // Call parent function to remove training from list

          } else {
            Swal.fire({ icon: 'error', text: 'Failed to delete training' });
          }
        })
        .catch(error => console.error('Error deleting training:', error));
    }
  };
  const handleApply = async (id) => {
    // Add logic to handle deleting training data
    console.log('Training applied:', id);
    const result = await Swal.fire({
      icon: 'question',
      text: 'Are you sure you want to apply this training?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });
    if (result.isConfirmed) {
      fetch(`${API_BASE_URL}/trainings/request_training.php?id=${id}`, {
        method: 'GET',
        credentials: 'include'
      })
      .then(response => {
        const contentType = response.headers.get('content-type');
    
        // Log the status and response text for debugging
        console.log('Response Status:', response.status);
        
        // Attempt to read the response as text first
        return response.text().then((text) => {
          console.log('Raw Response:', text); // Log the raw response text
          
          if (!response.ok) {
            // If response is not ok, throw an error with the response text
            throw new Error(`Failed with status ${response.status}: ${text}`);
          }
    
          // If response is JSON, parse it
          if (contentType && contentType.includes('application/json')) {
            return JSON.parse(text); // Parse JSON manually
          } else {
            // Return the raw text if it's not JSON
            return text;
          }
        });
      })
      .then(data => {
        console.log("data",data);
        // Check if the response is JSON or plain text
        if (typeof data === 'string') {
          console.log('Non-JSON response:', data);
          Swal.fire({ icon: 'error', text: `Received non-JSON response: ${data}` });
        } else if (data.success) {
          //navigate('/users');
          Swal.fire({ icon: 'success', text: 'Sucessfully apply for the training' });
        } else {
          console.error('PHP Error:', data.message); // Log PHP error to the console
          Swal.fire({ icon: 'error', text: `Failed to apply: ${data.message}` });
        }
      })
      .catch(error => {
        console.error('Error saving user:', error);
        Swal.fire({ icon: 'error', text: `Error: ${error.message}` });
      });
    }
  };

  const isPastTraining = (training) => {
    const today = new Date();
    const endDate = new Date(training.end_date); // assuming training ends at the end_date
    return endDate < today;
  };
  return (
    <div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Code</th>
            <th>Title</th>
            <th>Description</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Time</th>
            <th>Location</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {trainings.map((training,index) => (
            <tr key={training.id}>
              <td>{index + 1}</td>
              <td>{training.code}</td>
              <td>{training.title}</td>
              <td>{training.description}</td>
              <td>{training.start_date}</td>
              <td>{training.end_date}</td>
              <td>{training.time}</td>
              <td>{training.location}</td>
              <td>
                {/* Action links */}
                 {loggedInUser.role !== 'trainingadmin' && (
                        <>
                <Link to={`/training/view/${training.id}`}>
                <Button className="m-1"variant="primary">View Details</Button>
                </Link>
                </>
                )}
                {(loggedInUser.role === 'trainingadmin' || loggedInUser.role === 'masteradmin' || loggedInUser.role === 'admin') && !isPastTraining(training) && (
                  <>
                  <Link to={`/training-provider/edit-training/${training.id}`}>
                    <Button variant="primary" className="mr-2">Edit</Button>
                  </Link>
                  <Button 
                    variant="danger" 
                    onClick={() => handleDelete(training.id)}
                  >Delete</Button>
                </>
                 )}
          {/* Apply is a self-registration action for employees (and the
              admin roles that also act as employees per FEATURES.md) — not
              trainer/trainingadmin, who deliver trainings rather than
              attend them. */}
          {!['trainingadmin', 'trainer'].includes(loggedInUser.role) && (
                  <>
          <Button className="m-1"
                    variant="primary"
                    onClick={() => handleApply(training.id)}
                  >Apply</Button>
          </>
          )}
          {/* Assign/Attendance/Participants are managing actions — an
              employee has no access to the endpoints behind them (see
              get_training_attendance.php, get_training_participants.php,
              update_participant_status.php, assign_employee_helper.php),
              so the buttons are hidden for that role rather than shown and
              rejected server-side. */}
          {['admin', 'masteradmin', 'companyadmin', 'departmentadmin'].includes(loggedInUser.role) && (
          <Link to={`/training-provider/assign-training/${training.id}`}>
          <Button className="m-1"variant="primary">Assign</Button>
          </Link>
          )}
          {/* Editable attendance entry — restricted to Trainer/Training
              Admin (vendor)/Super Admin, matching attended_training.php.
              companyadmin/departmentadmin use the read-only Attendee List
              tab (on the training detail page) instead. */}
          {['admin', 'masteradmin', 'trainingadmin', 'trainer'].includes(loggedInUser.role) && (
          <Link to={`/training-provider/attendance/${training.id}`}>
          <Button className="m-1"variant="primary">Attendance</Button>
          </Link>
          )}
              {loggedInUser.role !== 'employee' && (
              <Link to={`/training-provider/registered-participants/${training.id}`}>
                    <Button variant="primary" className="mr-2">Participants</Button>
                  </Link>
              )}
                {loggedInUser.role === 'employee' && training.certificate_id && (
                  <a
                    href={`${API_BASE_URL}/certificates/download_certificate.php?id=${training.certificate_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary btn-sm m-1"
                  >
                    View Certificate
                  </a>
                )}
                {loggedInUser.role === 'employee' && training.competency_certificate_id && (
                  <a
                    href={`${API_BASE_URL}/certificates/download_certificate.php?id=${training.competency_certificate_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-warning btn-sm m-1"
                  >
                    View Competency Certificate
                  </a>
                )}

              </td>
            </tr>
          ))}
        </tbody>
      </Table>



    
    </div>
  );
}

export default UpcomingTrainings;
